import {SET_LOGGER} from '../actions/helpers.action.js';
import {default_state} from './index.js';

export function helpers(state = default_state.helpers, action={}){
    if (action.type != SET_LOGGER || !action.logger) return state;

    return {
        ...state,
        logger : action.logger
    };
}


// WEBPACK FOOTER //
// ./src/reducers/helpers.reducer.js